<div class="access-title">
	<div>Reportes</div>
	<div class="arrow__icon" [ngClass]="( isCollapsed$ | async )? '': 'expanded'" (click)="toggleCollapse( $event )" gtagEvent="colapsar" gtagCategory="reporte-widget">
		<span></span>
		<span></span>
	</div>
</div>

<div  [@smoothCollapse]="( isCollapsed$ | async )? 'collapsed': 'expanded'">

	<div class="access-content" routerLink="/principal/reportes/violencia-laboral" gtagEvent="ver-violencia-laboral" gtagCategory="reporte-widget">
		<div class="access-content__data-icon violencia-laboral-icon"></div>
		<div class="access-content__data">Reporte de violencia laboral</div>
	</div>
	<div class="access-content" [managedLink]="reporteIncidentesKey" gtagEvent="ver-incidentes-efectos" gtagCategory="reporte-widget">
		<div class="access-content__data-icon incidentes-efectos-icon"></div>
		<div class="access-content__data">Reporte de incidentes y efectos adversos</div>
	</div>
	<div class="access-content" routerLink="/principal/reportes/faltantes" gtagEvent="ver-faltantes" gtagCategory="reporte-widget">
		<div class="access-content__data-icon faltantes-icon"></div>
		<div class="access-content__data">Reporte de faltantes</div>
	</div>
	<div class="access-content" routerLink="/principal/reportes/emergencias" gtagEvent="ver-emergencia" gtagCategory="reporte-widget">
		<div class="access-content__data-icon emergencias-icon"></div>
		<div class="access-content__data">8700 Emergencias</div>
	</div>

</div>